import React from 'react';
import Slider from 'react-slick';
import { Box, Typography, Button, Container } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Keyframes for animations
const keyframes = `
  @keyframes zoomIn {
    from { transform: scale(1); }
    to { transform: scale(1.1); }
  }
  @keyframes slideInRight {
    from { 
      transform: translateX(100px); 
      opacity: 0; 
    }
    to { 
      transform: translateX(0); 
      opacity: 1; 
    }
  }
`;

const slides = [
    {
        image: require('../assets/image.psd.jpg'),
        title: 'Natural Stones',
        subtitle: 'A Strong Foundation for Tomorrow. We are leading manufacturer and supplier of cobble stone in bengaluru from India.   Our range of cobble stone available with Granite cobble stone. We…',
        path: 'a-strong-foundation-for-tomorrow'
    },
    {
        image: require('../assets/image.psd2_.jpg'),
        title: 'Where Dream and Desire Meets a New Building',
        subtitle: 'One of the most prestigious and recognized manufacturers, exporters, supplier of diverse varieties of natural stones. Our hot products which we manufacture on a very large scale are as follows…',
        path: 'banner'
    },
    {
        image: require('../assets/image.psd3_.jpg'),
        title: 'One-Stop Shop for all your Needs',
        subtitle: 'Stones, one of the god’s gift to manking is found in different colour and tones. To rekindle it and make it worth for us to use its beauty. We started…',
        path: 'one-stop-shop-for-all-your-needs'
    },
];

// Custom Arrow Components
const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <Box
            onClick={onClick}
            sx={{
                position: 'absolute',
                top: '50%', // Center vertically
                right: { xs: '10px', md: '20px' }, // Adjust padding
                transform: 'translateY(-50%)', // Ensure center alignment
                zIndex: 2,
                cursor: 'pointer',
                bgcolor: 'rgba(0,0,0,0.5)',
                color: 'white',
                p: { xs: 1, md: 1.5 },
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: '0.3s',
                '&:hover': { bgcolor: 'primary.main' }
            }}
        >
            <ArrowForwardIosIcon sx={{ fontSize: { xs: 16, md: 20 } }} />
        </Box>
    );
}

const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <Box
            onClick={onClick}
            sx={{
                position: 'absolute',
                top: '50%', // Center vertically
                left: { xs: '10px', md: '20px' }, // Adjust padding
                transform: 'translateY(-50%)', // Ensure center alignment
                zIndex: 2,
                cursor: 'pointer',
                bgcolor: 'rgba(0,0,0,0.5)',
                color: 'white',
                p: { xs: 1, md: 1.5 },
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: '0.3s',
                '&:hover': { bgcolor: 'primary.main' }
            }}
        >
            <ArrowBackIosIcon sx={{ fontSize: { xs: 16, md: 20 }, pl: 0.5 }} />
        </Box>
    );
}

const HeroSection = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true, // Note: fade might feel weird with stacked content on mobile if height changes, but let's keep consistent
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 900, // md
                settings: {
                    fade: false, // Slide effect on mobile often feels more natural for stacked content, but fade is fine too.
                    arrows: true // Ensure arrows are visible
                }
            }
        ]
    };

    return (
        <Box sx={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
            <style>{keyframes}</style>
            <Slider {...settings}>
                {slides.map((slide, index) => (
                    <Box key={index} sx={{ outline: 'none' }}>
                        <Box sx={{
                            position: 'relative',
                            height: { xs: 'auto', md: '90vh' },
                            display: { xs: 'flex', md: 'block' },
                            flexDirection: 'column',
                            overflow: 'hidden'
                        }}>

                            {/* Background Image with Zoom Animation */}
                            <Box
                                className="slide-background"
                                sx={{
                                    width: '100%',
                                    height: { xs: '30vh', md: '100%' }, // Decreased height on mobile
                                    minHeight: { xs: '250px', md: 'auto' },
                                    position: { xs: 'relative', md: 'absolute' },
                                    top: 0,
                                    left: 0,
                                    backgroundImage: `url(${slide.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    animation: { xs: 'none', md: 'zoomIn 10s ease-in-out infinite alternate' }, // Disable zoom on mobile static image to save perf/layout shift
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        bgcolor: 'rgba(0,0,0,0.4)', // Overlay
                                        display: { xs: 'none', md: 'block' } // Only overlay on desktop
                                    }
                                }}
                            />

                            {/* Text Content */}
                            <Box
                                sx={{
                                    position: { xs: 'relative', md: 'absolute' },
                                    top: { xs: 'auto', md: '50%' },
                                    left: { xs: 'auto', md: '50%' },
                                    transform: { xs: 'none', md: 'translate(-50%, -50%)' },
                                    width: '100%',
                                    height: { xs: 'auto', md: '100%' },
                                    bgcolor: { xs: '#212327', md: 'transparent' }, // Dark bg on mobile
                                    color: 'white',
                                    zIndex: 1,
                                    display: 'flex',
                                    alignItems: { xs: 'flex-start', md: 'center' }, // Vertical alignment
                                    justifyContent: { xs: 'center', md: 'center' },
                                    py: { xs: 6, md: 0 }
                                }}
                            >
                                <Container
                                    sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'flex-start',
                                        textAlign: 'left'
                                    }}
                                >
                                    {/* Animated Content Wrapper */}
                                    <Box sx={{ maxWidth: '1200px' }}>
                                        <Typography
                                            variant="h2"
                                            component="h1"
                                            key={index + '-title'}
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: { xs: '1.8rem', md: '4rem' }, // Adjusted for mobile
                                                mb: 2,
                                                textShadow: { xs: 'none', md: '2px 2px 4px rgba(0,0,0,0.5)' },
                                                animation: 'slideInRight 1s ease-out forwards',
                                                opacity: 0,
                                                animationDelay: '0.2s',
                                                lineHeight: 1.2,
                                                maxWidth: '1200px'
                                            }}
                                        >
                                            {slide.title}
                                        </Typography>
                                        <Typography
                                            variant="h5"
                                            key={index + '-desc'}
                                            sx={{
                                                mb: 4,
                                                fontWeight: 400,
                                                fontSize: { xs: '0.9rem', md: '18px' }, // Custom size
                                                textShadow: { xs: 'none', md: '1px 1px 2px rgba(0,0,0,0.5)' },
                                                animation: 'slideInRight 1s ease-out forwards',
                                                opacity: 0,
                                                animationDelay: '0.6s',
                                                maxWidth: '800px',
                                                color: { xs: '#b0b0b0', md: 'white' }
                                            }}
                                        >
                                            {slide.subtitle}
                                        </Typography>
                                        <Button
                                            variant={{ xs: 'contained', md: 'outlined' }} // Contained on mobile for visibility
                                            href={slide.path}
                                            key={index + '-btn'}
                                            endIcon={<ArrowForwardIcon />}
                                            sx={{
                                                borderColor: 'primary.main',
                                                bgcolor: 'primary.main',
                                                color: 'white', borderWidth: 2,
                                                fontSize: '0.9rem',
                                                padding: '10px 30px',
                                                animation: 'slideInRight 1s ease-out forwards',
                                                opacity: 0,
                                                animationDelay: '1s',
                                            }}
                                        >
                                            Continue reading
                                        </Button>
                                    </Box>
                                </Container>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Slider>
        </Box>
    );
};

export default HeroSection;
